/* 
Author:Lamiaa Moustafa
Desc: Register component
*/

import React, {useState} from "react";
import { FormInput } from "../../components/inputs/FormInput";
import { Button1st2911 } from "../../components/buttons/Button1st2911";
import Dropdown1st2911 from "../../components/dropdown1st2911";
import { SelectDiv } from "../../Styles/styledComponents/Divs";
import { selectStyle } from "../../Styles/styledComponents/ReactSelect";

const Register = () => {

  const [formValue, setFormValue] = useState({
    email: "",
    phoneNumber: "",
    badgeNumber: "",
  });

  const [selectValue, setSelectValue] = useState("");
  const handleChangeSelect = (selected) => {
    // setRegisterSuccess("");
    console.log(selected.value);
    setSelectValue(selected);
    setFormValue({ ...formValue, userRole: selected.value });
  };
  // const AdminOptions = [
  //   { id: 1, label: "First Responders", value: "firstResponders" },
  // ];
  const superAdminOptions = [
    { id: 1, label: "First Responders", value: "firstResponders" },
    { id: 2, label: "Admin", value: "Admin" },
    { id: 3, label: "Super Admin", value: "superAdmin" },
  ];
  
  return (
    <>
      <FormInput
        data={{
          name: "name",
          label: "First Name",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "name",
          label: "Last Name",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "email",
          label: "Email Address",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "number",
          label: "Phone Number",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "number",
          label: "Badge Number",
          width: "100%",
          height: "100px",
        }}
      />
    
     <SelectDiv>
      <Dropdown1st2911 data={{label: "Select User Role", placeholder:"Select...", width:'50%',options:superAdminOptions, customStyle:selectStyle,onchange:handleChangeSelect}}/>
      <Button1st2911 data={{ label: "REGISTER" }} />
      </SelectDiv>
    </>
  );
};
export default Register;

